import React, { useState } from 'react';
import { 
  FaHome, FaPercent, FaCheckCircle, FaChevronDown, 
  FaFileAlt, FaHandHoldingUsd, FaExchangeAlt, FaShieldAlt, FaBuilding 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const HomeLoan = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "What documents are typically required to apply for a home loan?",
      a: "Standard documentation includes KYC papers (Aadhaar, PAN), proof of income (salary slips, Form 16, or audited ITRs for self-employed applicants), bank statements for the last 6 months, and property ownership/legal documents."
    },
    {
      q: "What is a Home Loan Balance Transfer?",
      a: "A balance transfer allows you to move your existing home loan from your current lender to another bank or financial institution offering a lower interest rate. This can significantly reduce your monthly EMI or total interest payout over the remaining tenure."
    },
    {
      q: "Should I choose a Fixed or Floating interest rate?",
      a: "Floating interest rates fluctuate in response to market conditions and RBI repo rate changes, but they are typically lower than fixed rates. Fixed rates remain constant throughout the tenure (or a locked period), protecting you from rate hikes but usually costing slightly more initially."
    },
    {
      q: "How does Lotoswealth simplify the home loan process?",
      a: "We act as your dedicated mortgage advisors, comparing offers across top banks and housing finance companies to secure the most competitive interest rates, negotiating processing fees, and managing your paperwork from application to final disbursement."
    }
  ];

  return (
    <main className="home-loan-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Home Loan Services in Hyderabad | Best Housing Loan Advisors | Lotoswealth</title>

  <meta
    name="description"
    content="Lotoswealth provides expert Home Loan Services in Hyderabad, helping individuals and families secure the best housing loans with competitive interest rates, quick approvals, balance transfer options, loan refinancing, and personalized financial guidance."
  />

  <meta
    name="keywords"
    content="Home Loan Hyderabad, Home Loan Services Hyderabad, Housing Loan Hyderabad, Best Home Loan Hyderabad, Home Loan Advisor Hyderabad, Home Loan Consultant Hyderabad, Property Loan Hyderabad, Housing Finance Hyderabad, Home Loan Interest Rates Hyderabad, Home Loan Balance Transfer Hyderabad, Home Loan Refinancing Hyderabad, First Time Home Buyer Loan Hyderabad, Residential Property Loan Hyderabad, Mortgage Loan Hyderabad, Loan Against Property Hyderabad, Financial Advisor Hyderabad, Wealth Management Hyderabad, Investment Advisor Hyderabad, Home Finance Hyderabad, Lotoswealth"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/home-loan"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/home-loan"
  />
  <meta
    property="og:title"
    content="Home Loan Services in Hyderabad | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Get the best Home Loan Services in Hyderabad with Lotoswealth. Compare lenders, enjoy competitive interest rates, quick approvals, home loan balance transfers, and expert financial guidance."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Home Loan Services in Hyderabad | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Looking for the best Home Loan in Hyderabad? Lotoswealth helps you compare lenders, secure competitive interest rates, and get fast loan approvals with expert support."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/home-loan.jpg" 
            alt="Home Loan Advisory" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              Home Loan Solutions
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Turn Your Dream Home Into Reality With Competitive Financing
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth. Buying a home is one of life’s biggest financial milestones. Our Home Loan advisory services are designed to secure the right financing for you with competitive interest rates, quick sanctions, flexible tenures, and minimal documentation.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            We navigate the complex maze of banking institutions on your behalf. Whether you are purchasing a ready-to-move property, constructing a house, buying land, or looking to lower your existing EMI through a balance transfer, our experts guide you every step of the way.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Experience transparent mortgage advisory, seamless bank coordination, and stress-free loan processing with Lotoswealth.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY OUR HOME LOAN SERVICE MATTERS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Choose Lotoswealth for Your Home Loan?
              </h2>
              <p className="text-muted line-height-lg">
                Securing a home loan involves comparing dozens of lenders, evaluating complex floating vs. fixed interest rates, and navigating stringent legal verification processes. Choosing the wrong lender can cost lakhs in unnecessary interest.
              </p>
              <p className="text-muted line-height-lg">
                We simplify the entire mortgage journey. By leveraging our partnerships with leading banks and financial institutions, we help you secure preferential interest rates, fast-track approvals, and tailor repayment tenures to match your financial capacity.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">Key Advantages</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Competitive Rates:</strong> Access lowest available market interest rates.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Fast Approvals:</strong> Expedited loan processing and quick sanctions.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Minimal Documentation:</strong> Streamlined paperwork and door-step pickup.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Expert Guidance:</strong> End-to-end support from application to disbursement.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR HOME LOAN OFFERINGS (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🏠 Our Home Financing Options</h2>
            <p className="text-white">Tailored loan products designed to fit your specific property requirements.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaHome size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Home Purchase Loans</h5>
                <p className="text-muted small">Financing for buying ready-to-move-in apartments, under-construction properties, or resale homes with flexible repayment tenures up to 30 years.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBuilding size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Home Construction Loans</h5>
                <p className="text-muted small">Designed for individuals who own a plot of land and require structured financial disbursements to build their customized house step-by-step.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaExchangeAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Home Loan Balance Transfer</h5>
                <p className="text-muted small">Transfer your existing high-interest home loan to a new lender offering lower rates, reducing your overall EMI burden and total interest payout.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaHandHoldingUsd size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Top-Up Loans</h5>
                <p className="text-muted small">Avail additional funds over and above your existing home loan at attractive rates to finance home renovations, medical needs, or personal milestones.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaPercent size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Plot & Land Purchase Loans</h5>
                <p className="text-muted small">Specialized financing solutions to purchase residential plots approved by urban development authorities for future construction.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaShieldAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">NRI Home Loans</h5>
                <p className="text-muted small">Dedicated mortgage advisory for Non-Resident Indians looking to invest in residential property back home in India with streamlined remittance support.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR 5-STEP LOAN PROCESS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Our Home Loan Process</h2>
            <p className="text-light opacity-75">A streamlined, stress-free path to property ownership.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 1 – Eligibility & Consultation</h5>
                <p className="small text-muted mb-0">We evaluate your income, credit score (CIBIL), and financial profile to determine your maximum eligible loan amount.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 2 – Lender Matching</h5>
                <p className="small text-muted mb-0">Comparing offers across top banks and housing finance companies to secure the lowest interest rates and best terms.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 3 – Documentation & Application</h5>
                <p className="small text-muted mb-0">Assisting with paperwork collection, KYC verification, application submission, and coordinating bank processing.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 4 – Property Legal & Technical Audit</h5>
                <p className="small text-muted mb-0">Banks conduct property valuation and legal title verification to ensure clean ownership history before final sanction.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 5 – Sanction & Disbursement</h5>
                <p className="small text-muted mb-0">Final loan agreement signing and timely disbursement of funds to the builder or seller so you can move into your home.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Benefits from Our Home Loans?</h3>
              <p className="text-muted small mb-4">Our home financing advisory serves a wide spectrum of buyers:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "First-Time Home Buyers", "Salaried Professionals",
                  "Self-Employed Business Owners", "NRIs Buying Property in India",
                  "Plot Owners Building Houses", "Existing Borrowers Seeking Balance Transfers",
                  "Property Upgraders", "Real Estate Investors"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Trust Lotoswealth?</h3>
                <p className="text-muted small mb-4">Navigating mortgages can be complicated. Clients trust us with their home loans because we offer:</p>
                <div className="row g-3">
                  {[
                    "Tie-Ups with Leading Banks & HFCs", "Preferential Interest Rates & Fee Waivers",
                    "Expert Loan Structuring & Advisory", "Doorstep Document Collection",
                    "Dedicated Mortgage Relationship Managers", "Fast-Track Processing & Sanctions",
                    "Transparent Guidance & No Hidden Charges", "End-to-End Disbursement Support"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding Home Loans & Mortgages</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Buy Your Dream Home?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Secure the best home loan interest rates with hassle-free processing and expert support. Connect with our mortgage advisors today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Apply for a Home Loan Today
          </button>
        </div>
      </section>

    </main>
  );
};

export default HomeLoan;